export const FashionPictures = [
    {
        "id": 1,
        "title" : "LFW",
        "description" : "拍摄于伦敦，伦敦时装周 Photographed in London, London Fashion Week",
        "firstPic" : "https://files.seeusercontent.com/2026/06/27/7Vqi/1659688b_qXJrBVIMZlba6pd.jpg",
        "pics" : [ {
          "src" : "https://files.seeusercontent.com/2026/06/27/yA9k/51798317_m4UwGhArMSELPvB.jpg",
          "description" : ""
        }, {
          "src" : "https://files.seeusercontent.com/2026/06/27/lY3p/34e7dc5e_inz6Bt8maLkRGHI.jpg",
          "description" : ""
        }, {
          "src" : "https://files.seeusercontent.com/2026/06/27/4Wwl/b66083b3_B5s9XYA2HlzypSd.jpg",
          "description" : ""
        }, {
          "src" : "https://files.seeusercontent.com/2026/06/27/yj1V/4b776097_nYtbiZNcsSCufLM.jpg",
          "description" : ""
        }, {
          "src" : "https://files.seeusercontent.com/2026/06/27/X0bw/2c666d66_Uuh9TA517jRfSo3.jpg",
          "description" : ""
        }, {
          "src" : "https://files.seeusercontent.com/2026/06/27/i0lE/f93aee8e_RhnYH7EVWbjuoTy.jpg",
          "description" : ""
        }, {
          "src" : "https://files.seeusercontent.com/2026/06/27/7Vqi/1659688b_qXJrBVIMZlba6pd.jpg",
          "description" : ""
        }, {
          "src" : "https://files.seeusercontent.com/2026/06/27/0bXt/c03864b2_zSoAWk42Rx15JGy.jpg",
          "description" : ""
        } ]
      },
    {
        "id": 2,
        "title" : "Cyberpunk",
        "description" : "赛博朋克风格 Cyberpunk style",
        "firstPic" : "https://files.seeusercontent.com/2026/06/27/nlX4/a942b93c_arHQpgmq3txyfVF.jpg",
        "pics" : [ {
            "src" : "https://files.seeusercontent.com/2026/06/27/haD0/88bbad50_Te57vERNtOynrcl.jpg",
            "description" : ""
        }, {
            "src" : "https://files.seeusercontent.com/2026/06/27/nlX4/a942b93c_arHQpgmq3txyfVF.jpg",
            "description" : ""
        }, {
            "src" : "https://files.seeusercontent.com/2026/06/27/4Zsc/29d5d95d_Im97AZk4WFytRqL.jpg",
            "description" : ""
        }, {
            "src" : "https://files.seeusercontent.com/2026/06/27/W1xv/8da34ac5_kxvaAIhGP5qNEuJ.jpg",
            "description" : ""
        } ]
    }
];
